import { currentPage } from '../common/layout';

currentPage.pageInit = ($page, pageData, pageId) => {
  document.querySelectorAll('.contacts-toggler').forEach((button) => {
    button.addEventListener('click', () => {
      const body = button.nextElementSibling;
      button.classList.toggle('active');
      const isOpen = body.classList.contains('open');
  
      if (isOpen) {
        body.classList.add('close');
        body.classList.remove('open');
      } else {
        requestAnimationFrame(() => {
          body.classList.add('open');
          body.classList.remove('close');
        });
      }
    });
  });
};
